import { TableRow, TableCell, Typography } from "@mui/material";


type DisplayConnectionErrorProps = {

    errorMessage: string;
    title: string,

};


export const DisplayConnectionError: React.FC<DisplayConnectionErrorProps> = ( props: DisplayConnectionErrorProps ) => {

    const { errorMessage, title } = props;

    return (

        <TableRow  sx={{ '&:last-child td, &:last-child th': { border: 0 } }} hover>
            <TableCell component="th" scope="row">
                <Typography
                    component="span"
                    color="inherit"
                    sx={{color:'red'}}
                    noWrap
                >
                    {`${title}*`}
                </Typography>
            </TableCell>
            <TableCell colSpan={2} align='center'>
                <Typography
                    component="span"
                    color="inherit"
                    sx={{color:'red'}}
                    noWrap
                >
                    {errorMessage}
                </Typography>

            </TableCell>
        </TableRow>
    
    );

}